/**
 * CSS переменная для сдвига drawer при открытии виртуальной клавиатуры
 * Используется для корректировки позиции drawer на мобильных устройствах
 */
export const VIRTUAL_KEYBOARD_OFFSET_VAR = '--virtual-keyboard-offset';

/**
 * Конфигурация для drawer
 */
export const DRAWER_CONFIG = {
    /** Отношение положительного движения шторки к размеру шторки, при котором шторка закрывается */
    CLOSE_COEFFICIENT: 0.5,
    /** Скорость движения пальцев, при котором шторка закрывается */
    CLOSE_VELOCITY: 0.1,
    /** Абсолютное значение, пройденное дровером, для закрытии вирутальной клавиатуры  */
    CLOSE_VIRTUAL_KEYBOARD_PX: 30,
};
